import React from 'react'
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import usePopUp from '../../../hooks/usePopUp';

export const SixDronesPlusPopover = ({ handleClose, handleOpen, handleAgree, isOpen }) => {
    const onAgreeHandler = () => {
        handleAgree();
        handleClose();
    }

    return (
        <Dialog
            open={isOpen}
            onClose={handleClose}
            aria-labelledby="six-drones-fleet-dialog"
            aria-describedby="six-drones-fleet-dialog">
            <DialogTitle>Complete your purchase on the fleets portal</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    In order to complete your purchase, you will be redirected to the Skywatch fleets portal.
                </DialogContentText>
            </DialogContent>
            <DialogActions>
            <Button onClick={handleClose} color="primary">
                Cancel
            </Button>
            <Button onClick={onAgreeHandler} color="primary" autoFocus>
                Confirm
            </Button>
            </DialogActions>
        </Dialog>
    );
}